import React from 'react';
import { useDispatch } from 'react-redux';
import { reset } from 'redux-form';
import DownlinkTestForm from './components/DownlinkTestForm';
import { onDownLinkTest } from '../../core/services/stateless.services';

const DownlinkTest = (props: any) => {

  const dispatch = useDispatch();

  const onSubmitForm = (values: any) => {
    let jsonText=values.JSONText;
    let iccid=values.ICCID;
    let mode= values.Mode;
    onDownLinkTest(iccid, jsonText, mode);
    onModalClosed();
  }

  const onModalClosed = () => {
    dispatch(reset('DownlinkTestForm'));
    props.modalClosed();
  }

  return (
    <React.Fragment>
      <DownlinkTestForm
        submitHandler={onSubmitForm}
        onModalClosed={onModalClosed}
      />
    </React.Fragment>
  );
};

export default DownlinkTest;
